@if (hasMenu) {
  <icon-triggered-context-menu [menuItemsFactory]="menuItemsFactory" />
}
